module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined))
  }, [(_vm.show) ? _c('wxc-overlay', _vm._b({
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined)),
    attrs: {
      "show": _vm.show && _vm.hasOverlay
    },
    on: {
      "wxcOverlayBodyClicking": _vm.wxcOverlayBodyClicking,
      "wxcOverlayBodyClicked": _vm.wxcOverlayBodyClicked
    }
  }, 'wxc-overlay', _vm.mergeOverlayCfg, false)) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    ref: "wxc-mask",
    staticClass: "wxc-mask",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.maskStyle)),
    attrs: {
      "hack": _vm.shouldShow
    }
  }, [_c('div', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.contentStyle))
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showClose) ? _c('div', {
    staticClass: "mask-bottom",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle({
      width: _vm.width + 'px'
    })),
    on: {
      "click": _vm.closeIconClicked
    }
  }, [_c('image', {
    staticClass: "mask-close-icon",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined)),
    attrs: {
      "src": _vm.closeIcon,
      "aria-label": "关闭"
    }
  })]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b9aece2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b9aece2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-mask/index.vue
// module id = 183
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28